// extracted by mini-css-extract-plugin
export var button = "_72-7";
export var buttonRow = "_72-6";
export var fadeIn = "_72-1";
export var gradient = "_72-0";
export var panel = "_72-2";
export var panelIn = "_72-3";
export var subtitle = "_72-5";
export var title = "_72-4";